export const F_METHOD_GET = []
export const F_METHOD_CALL = []
export const F_METHOD_WATCH = []
export const F_METHOD_REF = []

export interface $F_G {}

export interface $F_C {}

export interface $F_W {}

export interface $F_R {}

export interface $F extends $F_G, $F_C, $F_W, $F_R {}
